import { render, staticRenderFns } from "./AdminAppNotificationsTable.vue?vue&type=template&id=13f5b33a&scoped=true"
import script from "./AdminAppNotificationsTable.vue?vue&type=script&lang=js"
export * from "./AdminAppNotificationsTable.vue?vue&type=script&lang=js"
import style0 from "./AdminAppNotificationsTable.vue?vue&type=style&index=0&id=13f5b33a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f5b33a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-api/api.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13f5b33a')) {
      api.createRecord('13f5b33a', component.options)
    } else {
      api.reload('13f5b33a', component.options)
    }
    module.hot.accept("./AdminAppNotificationsTable.vue?vue&type=template&id=13f5b33a&scoped=true", function () {
      api.rerender('13f5b33a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/AdminAppNotificationsTable.vue"
export default component.exports